import PropTypes from 'prop-types';
import ensureHtml from '../../../../services/ensureHtml';

export const name = 'ensureHtml';
export const propType = PropTypes.bool;
export const defaultProp = true;
export const onParse = ensureHtml;
